import React from 'react';
import './WidgetBlock.scss';

class WidgetBlock extends React.Component {
  getBlockInfo() {
    const {block, contentState, blockProps} = this.props;

    const targetBlock = block.getEntityAt(0);
    if (!targetBlock) {
      // Prevent creation of new invalid block when pressing Enter inside this block
      // TODO: Prevent this some other way?
      return null;
    }

    const data = contentState.getEntity(targetBlock).getData();
    let widget = data.widget;
    let widgetData = data.data;

    if (blockProps.widget !== undefined && blockProps.widget !== null) {
      widget = blockProps.widget;
    }
    if (blockProps.data !== undefined && blockProps.data !== null) {
      widgetData = blockProps.data;
    }

    return {
      block,
      contentState,
      data,
      widget,
      widgetData
    };
  }

  render() {
    const blockInfo = this.getBlockInfo();

    if (!blockInfo) {
      return null;
    }

    return <div className="widget-block widget-lease-basic">
      <h2>Lease</h2>
      <p>{blockInfo.widget}</p>
    </div>;
  }
}

export default WidgetBlock;
